<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    viewBox="0 0 32 32"
    :class="customStyle"
  >
    <path
      d="m25.7 9.3-7-7A.91.91 0 0 0 18 2H8a2 2 0 0 0-2 2v24a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V10a.91.91 0 0 0-.3-.7ZM18 4.4l5.6 5.6H18ZM24 28H8V4h8v6a2 2 0 0 0 2 2h6Z"
    />
    <path d="M21 19h-4v-4h-2v4h-4v2h4v4h2v-4h4v-2z" />
    <path
      fill="none"
      d="M0 0h32v32H0z"
      data-name="&lt;Transparent Rectangle&gt;"
    />
  </svg>
</template>

<script>
export default {
  name: 'FileDocumentPlus',
  props: {
    customStyle: {
      type: String,
      default: 'h-5 w-5',
    },
  },
}
</script>
